import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from "../img/logo.svg";
import { faFacebookSquare, faInstagramSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';
import { motion, useInView } from 'framer-motion';

const Footer = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <footer ref={ref} className="footer">
      <div className="footer-container">
        <motion.div 
          className="footer-brand-section"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
        >
          <Link to="/">
            <img src={logo} className="footerlogo" alt="Logo"/>
          </Link>
          <div className="social-icons">
            <a title="instagram" href="https://www.instagram.com/saturnusclub">
              <FontAwesomeIcon icon={faInstagramSquare} className="socialiconfooter"/>
            </a>
            <a title="facebook" href="https://facebook.com/saturnusclub">
              <FontAwesomeIcon icon={faFacebookSquare} className="socialiconfooter"/>
            </a>
            <a title="youtube" href="https://youtube.com/@saturnusclub">
              <FontAwesomeIcon icon={faYoutubeSquare} className="socialiconfooter"/>
            </a>
          </div>
        </motion.div>
        <motion.div 
          className="footer-links-section"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="columns">
            <div className="column is-4 nopadding nomargin footerlinks has-text-centered">
              <ul className="menu-list">
                <li>
                  <Link className="menu-item" to="/academy">
                    Academy
                  </Link>
                </li>
                <li>
                  <Link className="menu-item" to="/study">
                    Study
                  </Link>
                </li>
                <li>
                  <Link className="menu-item" to="/tools">
                    Tools
                  </Link>
                </li>
              </ul>
            </div>
            <div className="column is-4 nopadding nomargin footerlinks has-text-centered">
                <ul className="menu-list">
                  <li>
                    <Link to="/faq" className="menu-item">
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link className="menu-item" to="/about">
                      About
                    </Link>
                  </li>
                <li>
                  <Link className="menu-item" to="/contact">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="column is-4 nopadding nomargin footerlinks has-text-centered">
              <ul className="menu-list">
                <li>
                  <Link to="/messages" className="menu-item">
                    Messages
                  </Link>
                </li>
                <li>
                  <Link to="/library" className="menu-item">
                    Library
                  </Link>
                </li>
                <li>
                  <Link to="/journal" className="menu-item">
                    Journal
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
